import JSZip from "jszip";
import mime from "mime";

export async function downloadAsZip(downloadList, callback?: Function) {
  if (!downloadList || downloadList.length === 0) {
    console.error("Download list is empty or invalid.");
    return;
  }

  const zip = new JSZip();
  const fileNamesInZip = new Set(); // 用来存储已经添加到 zip 中的文件名

  for (let index = 0; index < downloadList.length; index++) {
    const url = downloadList[index];
    try {
      const response = await fetch(url);
      if (response.ok) {
        const blob = await response.blob();
        if (blob.size === 0) {
          console.warn(`Skipped empty file: ${url}`);
          continue;
        }

        const contentType = response.headers.get("Content-Type");

        // 提取文件名并去除查询参数
        let fileName =
          url.split("/").pop()?.split("?")[0] || `file-${index + 1}`;

        // 检查文件是否有后缀名
        const hasExtension =
          fileName.includes(".") && fileName.split(".").pop().length <= 5;

        // 如果没有后缀名并且能根据 MIME 类型获取到扩展名，则添加扩展名
        if (!hasExtension && contentType) {
          const fileExt = mime.getExtension(contentType);
          fileName = fileExt ? `${fileName}.${fileExt}` : `${fileName}.bin`; // 默认后缀为 .bin
        }

        // 替换非法字符并限制文件名长度
        fileName = fileName.substring(0, 50).replace(/[\\:*?"<>|]/g, "_");

        // 确保文件名唯一，若有相同文件名，则在前面加上索引进行区分
        let uniqueFileName = fileName;
        let counter = 1;
        while (fileNamesInZip.has(uniqueFileName)) {
          // 如果文件名重复，在文件名前添加索引来区分
          uniqueFileName = `${fileName.split(".")[0]}_${counter}.${fileName.split(".").pop()}`;
          counter++;
        }

        // 将唯一文件名添加到集合中
        fileNamesInZip.add(uniqueFileName);

        console.log(
          `File to add: ${uniqueFileName}, size: ${blob.size}, type: ${blob.type}`,
        );
        zip.file(uniqueFileName, blob); // 添加文件到 zip
      } else {
        console.error(`Failed to fetch: ${url}, status: ${response.status}`);
      }
    } catch (error) {
      console.error(`Error fetching ${url}:`, error);
    }
  }

  try {
    const content = await zip.generateAsync({ type: "blob" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(content);

    // 设置文件名
    const currentTime = new Date();
    const formattedTime = currentTime
      .toISOString()
      .replace("T", "_")
      .slice(0, 19)
      .replace(/:/g, "-");

    a.download = `${formattedTime}.zip`;
    document.body.appendChild(a);
    a.click();
    callback();
    document.body.removeChild(a);
  } catch (zipError) {
    console.error("Error during ZIP generation:", zipError);
  }
}
